<template>
  <main>
    <CardInfo/>
    <FilmList
      :has-card="hasCard"
      :card="card"
      type="report"/>
  </main>
</template>

<script>
import bus from '@/libs/bus';

const CardInfo = () => import('@/components/CardInfo.vue');
const FilmList = () => import('@/components/FilmList.vue');

export default {
  name: 'Report',
  components: {
    CardInfo,
    FilmList,
  },
  data() {
    return {
      hasCard: false,
      card: {},
    };
  },
  mounted() {
    bus.$on('load-card', (status, value) => {
      this.hasCard = status;
      if (status) {
        this.card = value;
      }
    });
  },
};
</script>
